import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/Layout";
import Home from "@/pages/Home";
import ServicesPage from "@/pages/ServicesPage";
import PhotosPage from "@/pages/PhotosPage";
import BookPage from "@/pages/BookPage";
import FounderPage from "@/pages/FounderPage";
import ReviewsPage from "@/pages/ReviewsPage";
import VisitPage from "@/pages/VisitPage";
import MorePage from "@/pages/MorePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="photos" element={<PhotosPage />} />
            <Route path="book" element={<BookPage />} />
            <Route path="founder" element={<FounderPage />} />
            <Route path="reviews" element={<ReviewsPage />} />
            <Route path="visit" element={<VisitPage />} />
            <Route path="more" element={<MorePage />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
